export const ConfirmationLink = () => {
    return (
        <section className="py-8 text-center">
            <a
                href='/confirmation'
                target="_blank"
                className="amatic-sc-bold cursor-pointer block md:inline mx-auto rounded-md md:w-1/2 w-80 bg-emerald-950 px-5 py-2 text-xl md:text-2xl  font-semibold text-white outline-4 outline-senary transition-all hover:bg-senary disabled:pointer-events-none disabled:opacity-50"
                rel="noreferrer"
                >
                <button>Confirme sua presença aqui</button>
              </a>
        </section>
    )
}